import { FullContainer } from '@gorila-shared-ui/components';
import { generatePath, useParams } from 'react-router-dom';
import { FLEET_REPORTS_PAGE } from '../../../constants/fleet';
import { useStyles } from '../../../hooks/useStyles';
import { FleetAssetServiceList } from '../../fleet/reports/FleetAssetServiceList';
import FleetAssetServicesFiltersBar from '../../fleet/reports/FleetAssetServicesFiltersBar';
import CustomBreadcrumbs from '../../shared/CustomBreadcrumbs';

function FleetServiceReportsPage() {
  const { classes } = useStyles();
  const { id: workspaceId } = useParams();
  const redirectPath = workspaceId ? generatePath(FLEET_REPORTS_PAGE.route, { id: workspaceId }) : '/';

  return (
    <FullContainer verticalFlex>
      <CustomBreadcrumbs
        historic={[
          {
            path: redirectPath,
            label: 'Reportes',
          },
          {
            label: 'Servicios',
          },
        ]}
      />
      <FullContainer
        verticalFlex
        classNames={classes.basicPageContainer}
      >
        <FleetAssetServicesFiltersBar />
        <FleetAssetServiceList />
      </FullContainer>
    </FullContainer>
  );
}

export default FleetServiceReportsPage;
